import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import money from "astrid-helpers/src/money";

import Label from "../../../ui/components/Label/Label";

import Form from "../../../forms/components/Form/Form";

import useDistributionPriceTypeOptions from "../../hooks/useDistributionPriceTypeOptions";
import useDistributionPriceTypeTranslations from "../../hooks/useDistributionPriceTypeTranslations";

export default function DistributionPriceForm({ name, publisher }) {
	const { t } = useTranslation();

	const { setValue } = useFormContext();

	const currencyOptions = useMemo(() => {
		return publisher.currencyOptions?.map((option) => ({ key: option, value: option, text: option })) || [];
	}, [publisher.currencyOptions]);

	const priceTypeOptions = useDistributionPriceTypeOptions();
	const priceTypeTranslations = useDistributionPriceTypeTranslations();

	return (
		<Form.FormFieldArrayTable
			name={name}
			header={t("prices", "Prices")}
			onAppend={() => ({ currency: publisher.currencyDefault, edit: true })}
		>
			{({ type, edit, currency, amount }, index) => {
				if (!edit) {
					return (
						<Label
							onClick={() => setValue(`contributors.${index}.edit`, true)}
							style={{ cursor: "pointer" }}
						>
							{priceTypeTranslations[type]} - {money(amount, currency)}
						</Label>
					);
				}

				return (
					<Form.Group widths="equal">
						<Form.Select
							fluid
							name={`${name}.${index}.type`}
							value={type}
							placeholder={t("priceType", "Price type")}
							options={priceTypeOptions}
						/>

						<Form.Select
							fluid
							name={`${name}.${index}.currency`}
							value={currency}
							placeholder={t("currency", "Currency")}
							options={currencyOptions}
						/>

						<Form.NumberInput
							fluid
							name={`${name}.${index}.amount`}
							value={amount}
							placeholder={t("amount", "Amount")}
						/>
					</Form.Group>
				);
			}}
		</Form.FormFieldArrayTable>
	);
}
